// removed by extract-text-webpack-plugin
module.exports = {"card":"general__card___1e_k- height-100 transitionDuration-m position-relative","outer":"general__outer___2uRkS height-100 transitionDuration-m","extraElement":"general__extraElement___lscz1 bg-white display-block position-absolute width-95","cardCount":"general__cardCount___27XpT bg-orange borderRadius-circle c-white display-inlineBlock fontWeight-5 fontSize-s textAlign-center position-absolute"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-card/Card/style/general.css
// module id = 139
// module chunks = 0 1